<div class="text">
  <p>
    {{
      'RESOURCE_LIFECYCLE_WARNING'
        | translate
          : {
              displayName: displayName,
              endLifeCycle: endOfLife | date: 'dd.MM.yyyy',
            }
    }}
  </p>
</div>

<div class="button-container">
  <button
    mat-flat-button
    class="button"
    color="primary"
    (click)="renewLifecycle()"
  >
    {{ 'Renew' | translate }}
  </button>
  <button
    mat-flat-button
    class="button"
    color="primary"
    (click)="deleteResource()"
  >
    {{ 'Delete' | translate }}
  </button>
</div>

<br />

<hr />
